/**
 * Cookie Consent (Google Consent Mode v2)
 *
 * Sbira volbu uzivatele z listy a posila 'consent update' do Google.
 * Vychozi 'consent default' (denied) je nastaven inline v header.php pred GTM.
 */
(function () {
    'use strict';

    var COOKIE_NAME = 'dp_cookie_consent';
    var COOKIE_DAYS = 180;

    var root = document.getElementById('cookieConsent');
    if (!root) {
        return;
    }

    var introView = root.querySelector('[data-cc-view="intro"]');
    var settingsView = root.querySelector('[data-cc-view="settings"]');

    // --- Cookie helpers ---
    function readConsent() {
        var match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_NAME + '=([^;]*)'));
        if (!match) {
            return null;
        }
        try {
            return JSON.parse(decodeURIComponent(match[1]));
        } catch (e) {
            return null;
        }
    }

    function writeConsent(prefs) {
        var value = encodeURIComponent(JSON.stringify(prefs));
        var expires = new Date();
        expires.setTime(expires.getTime() + COOKIE_DAYS * 24 * 60 * 60 * 1000);
        document.cookie = COOKIE_NAME + '=' + value +
            ';expires=' + expires.toUTCString() +
            ';path=/;SameSite=Lax';
    }

    // --- Consent Mode update ---
    function applyConsent(prefs) {
        var analytics = prefs.analytics ? 'granted' : 'denied';
        var marketing = prefs.marketing ? 'granted' : 'denied';

        if (typeof window.gtag === 'function') {
            window.gtag('consent', 'update', {
                'analytics_storage': analytics,
                'ad_storage': marketing,
                'ad_user_data': marketing,
                'ad_personalization': marketing
            });
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'consent_update',
            consent_analytics: prefs.analytics,
            consent_marketing: prefs.marketing
        });
    }

    // --- UI ---
    function showBanner(view) {
        root.classList.add('cookie-consent--open');
        root.setAttribute('aria-hidden', 'false');
        toggleView(view || 'intro');
    }

    function hideBanner() {
        root.classList.remove('cookie-consent--open');
        root.setAttribute('aria-hidden', 'true');
    }

    function toggleView(view) {
        var showSettings = view === 'settings';
        if (introView) {
            introView.hidden = showSettings;
        }
        if (settingsView) {
            settingsView.hidden = !showSettings;
        }
    }

    function syncToggles(prefs) {
        var inputs = root.querySelectorAll('[data-cc-category]');
        for (var i = 0; i < inputs.length; i++) {
            var cat = inputs[i].getAttribute('data-cc-category');
            inputs[i].checked = !!prefs[cat];
        }
    }

    function readToggles() {
        return {
            analytics: !!root.querySelector('[data-cc-category="analytics"]:checked'),
            marketing: !!root.querySelector('[data-cc-category="marketing"]:checked')
        };
    }

    function save(prefs) {
        prefs.ts = Math.floor(Date.now() / 1000);
        prefs.v = 1;
        writeConsent(prefs);
        applyConsent(prefs);
        hideBanner();
    }

    // --- Event binding ---
    root.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-cc-action]');
        if (!trigger) {
            return;
        }
        var action = trigger.getAttribute('data-cc-action');

        if (action === 'accept') {
            save({ analytics: true, marketing: true });
        } else if (action === 'reject') {
            save({ analytics: false, marketing: false });
        } else if (action === 'settings') {
            toggleView('settings');
        } else if (action === 'save') {
            save(readToggles());
        }
    });

    // Odkaz "Nastaveni cookies" (napr. ve footeru) znovu otevre listu.
    document.addEventListener('click', function (e) {
        var trigger = e.target.closest('.js-cookie-settings');
        if (!trigger) {
            return;
        }
        e.preventDefault();
        syncToggles(readConsent() || {});
        showBanner('settings');
    });

    // Pri prvni navsteve (bez ulozene volby) zobraz listu.
    if (!readConsent()) {
        showBanner('intro');
    }
})();
